import axios from 'axios';
import { urls } from '../../services/urls';

export const sendContactMessage = newMessage => {
  return axios({
    method: 'post',
    url: urls['send_contact_message'],
    headers: {
      'Content-Type': 'application/json'
    },
    params: {
      'contact_message[full_name]': newMessage['fullName'],
      'contact_message[email]': newMessage['email'],
      'contact_message[phone_number]': newMessage['phoneNumber'],
      'contact_message[message]': newMessage['message'],
      'contact_message[subscribe_newsletter]': newMessage['subscribeNewsletter']
    }
  });
};



// WEBPACK FOOTER //
// ./app/javascript/pages/contact/services.js